<template>
	<div>
		<el-dialog title="有可用的音频驱动程序" :visible.sync="dtsData.dialogStatus" width="500px" :show-close="false" :close-on-click-modal="false">
			<div class="tip ">
				<div >好消息!您已准备好进行DTS:X升级，它将通过空间音效和均衡器控件增强您的聆听体验。</div>
				<br>
				<div >额外的音频处理会导致延迟增加。您随时可以卸载驱动程序。</div>
			</div>
			<div class="btns flexJA flexFe">
				<div class="btn flexJA" @click="bindHide" >以后再说</div>
				<div class="btn flexJA btn-1" @click="DtsInstallDrivers" >安装</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		data() {
			return {
				d: true
			}
		},
		computed: {
			...mapState({
				dtsData: (state) => state.dtsData,
				update: (state) => state.update,
				UpdateTIme: (state) => state.UpdateTIme,
				Upgrade: (state) => state.Upgrade,
				equipmentStatus: (state) => state.equipmentStatus,
			}),
		},
		mounted() {
			// this.SetFilePath();
		},
		methods: {
			DtsInstallDrivers() {
				// 安装 DTS 驱动程序（包含文件复制、INF 安装、服务注册）
				this.$store.commit('gotState', {key: 'dtsData', data: {status: false, dialogStatus: false}});
				window.LZPlugin.nativeCall("DtsInstall.dll","install_dts",null).then(res=>{
					console.log('DtsInstall.dll[install_dts]: ', res);
					// localStorage.setItem('dts', true);
					if(res.code == 0) {
						localStorage.setItem('dts', 1);
					}
				}).catch(err => {
					console.error('DtsInstall.dll[install_dts]: ', err)
				});
			},
			bindHide() {
				this.$store.commit('gotState', {key: 'dtsData', data: {status: false, dialogStatus: false}});
				// localStorage.setItem('dts', true);
			},
		}
	}
</script>

<style scoped lang="scss">
	@import '@/assets/css/deep.scss';
</style>